import { Box, Container, Grid, Typography } from "@material-ui/core";
import { assetIds, ThemedAsset } from "nemuru-components";
import React from "react";
import ResponsiveLayout from "./ResponsiveLayout";
import { useTheme } from "@material-ui/styles";
import Text from "./Text";
import ResponsiveDialog from "./ResponsiveDialog";

export default function CriticalErrorMessage({ message }) {
  const { palette } = useTheme();
  return (
    <ResponsiveDialog
      PaperProps={{
        "aria-label": "Critical error message dialog",
      }}
      className={"appear-anim"}
      displayCondition={true}
      fullScreenCondition={true}
      open={message !== null}
    >
      <Container style={{ padding: "1rem 1rem", height: "100%" }}>
        <ResponsiveLayout>
          <Box />

          <Box
            mt={4}
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            className="appear-anim"
          >
            <ThemedAsset
              id={assetIds.ICON_FAIL}
              width={50}
              height={50}
              style={{ color: palette.error.main }}
            />
            <Grid
              container
              display="flex"
              direction="column"
              alignItems="center"
              justifyContent="center"
              style={{ paddingTop: 20 }}
            >
              <Typography
                color={palette.text.title}
                variant={"h6"}
                className={"mb-1 transition-all"}
              >
                <strong>
                  <Text tId={"OOPS_SOMETHING_WENT_WRONG"} />
                </strong>
              </Typography>
              <Typography
                variant={"body2"}
                className={"mb-3 transition-all"}
                style={{
                  color: palette.text.primary,
                  textAlign: "center",
                }}
              >
                <Text tId={"PLEASE_RESET_THE_APP"} />
              </Typography>
            </Grid>
          </Box>
          <Box />
        </ResponsiveLayout>
      </Container>
    </ResponsiveDialog>
  );
}
